import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { ServiceStock } from './service-stock.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  switchLanguage(language: string) {
    this.services.translate.use(language);
  }

  constructor(public services: ServiceStock, private router: Router) {

    this.services.translate.setDefaultLang('En');
    this.services.translate.use('En');
    this.services.http.currentLanguage = 'En';
  }

  ngOnInit() {
    //Disable F5 Refresh
    window.addEventListener("keyup", disableF5);
    window.addEventListener("keydown", disableF5);

    function disableF5(e) {
      if ((e.which || e.keyCode) == 116) e.preventDefault();
    };
  }

}
